<template>
  <div class="branch-wrap">
    <div class="branch-node-wrap">
      <button class="add-branch" @click="handlerAddNode(sourceData.conditionList, 7)">{{ $t('work_rule_22') }}</button>
      <div v-for="(item, i) in sourceData.conditionList" :key="i" class="branch-node-box">
        <!-- 左测 隐藏线 -->
        <template v-if="i === 0">
          <div class="top-left-cover-line cover-line" />
          <div class="bottom-left-cover-line cover-line" />
        </template>
        <!-- 右侧隐藏线 -->
        <template v-if="i === sourceData.conditionList.length - 1">
          <div class="top-right-cover-line cover-line" />
          <div class="bottom-right-cover-line cover-line" />
        </template>
        <!-- 条件节点 -->
        <div class="condition-node-box">
          <div
            class="branch-node"
            :class="{ 'flow-node-selected': item.id === selectedId }"
            @click.stop="handlerSelected(item)"
          >
            <!-- 校验提醒 -->
            <el-tooltip v-if="item.warning.status" effect="light" :content="item.warning.msg" placement="bottom">
              <label class="warn-box">
                <i class="el-icon-warning" />
              </label>
            </el-tooltip>
            <!-- 左右位移 -->
            <template>
              <div
                v-if="handlerIsArrow(i)[0]"
                class="to-left-arrow branch-arrow"
                @click.stop="changePosition(i, i - 1)"
              >
                <i class="el-icon-arrow-left" />
              </div>
              <div
                v-if="handlerIsArrow(i)[1]"
                class="to-right-arrow branch-arrow"
                @click.stop="changePosition(i, i + 1)"
              >
                <i class="el-icon-arrow-right" />
              </div>
            </template>
            <!-- 标题操作栏 -->
            <div class="branch-title">
              <!-- edit name -->
              <input
                ref="inputs"
                v-model="name"
                type="text"
                class="title-input"
                :placeholder="$t('850')"
                @blur="handlerSave(item, i)"
                @keyup.enter="handlerSave(item, i)"
                :key="item.nodeCode"
              />
              <!-- 名称 -->
              <span ref="title" class="branch-title-name" @click.stop="handlerEdit(item, i)">{{ item.nodeName }}</span>
              <!-- 优先级 -->
              <span class="branch-level">{{ $t('work_rule_51', { x: i + 1 }) }}</span>
              <!-- 关闭 -->
              <button v-if="!item.isDefault" class="active-ctrl branch-action" @click.stop="del(item, i)">
                <i class="el-icon-close" />
              </button>
            </div>
            <!-- 添加条件 -->
            <div class="branch-content ellipsis textarea-style" :placeholder="$t('work_rule_21')">
              <span v-if="labels[i]">{{ labels[i] }}</span>
            </div>
          </div>
          <!-- 添加节点 -->
          <add-action :source-data="item" />
        </div>
        <Branch v-if="item.conditionList" :source-data="item" :del="del" :selected-id="selectedId" />
        <!-- 递归循环 -->
        <component
          :is="comp"
          v-if="item.childNode"
          :key="item.id"
          :source-data="item.childNode"
          :del="del"
          :selected-id="selectedId"
        />
      </div>
    </div>
    <!-- 添加节点 -->
    <add-action :source-data="sourceData" :branch="true" />
  </div>
</template>

<script>
import addAction from './add-action.vue'
import { handlerBranch, showData } from '../util'

export default {
  name: 'Branch',
  components: {
    addAction
  },
  props: {
    sourceData: {
      type: Object,
      default: () => []
    },
    del: {
      type: Function,
      default: () => () => {}
    },
    selectedId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      name: '',
      comp: () => import('./flow-node')
    }
  },
  computed: {
    labels() {
      const conditionList = this.sourceData.conditionList
      const len = conditionList.length
      return conditionList.map((item, index) => {
        return handlerBranch(item, index, len)
      })
    }
  },
  inject: ['handlerSelected', 'handlerAddNode'],
  methods: {
    showData,
    // 修改名称input展示
    handlerEdit(params, i) {
      if (params.isDefault) return false
      this.name = params.nodeName
      const el = this.$refs.inputs[i]
      const title = this.$refs.title[i]
      el.style.display = 'block'
      title.style.display = 'none'
      this.$nextTick(() => {
        el.select()
        el.focus()
      })
    },
    // 保存名称修改
    handlerSave(item, i) {
      const el = this.$refs.inputs[i]
      const title = this.$refs.title[i]
      el.style.display = 'none'
      title.style.display = 'block'
      if (this.name) item.nodeName = this.name
    },
    // 位移更改权重
    changePosition(i, n) {
      const { conditionList } = this.sourceData
      const data = conditionList[n]
      this.$set(conditionList, n, conditionList[i])
      this.$set(conditionList, i, data)
    },
    /**
     *  @description 左右位移展示逻辑
     *  @param { Object } item 当前节点
     *  @param { Number } i 节点下标
     *  @returns { Array } 数组里边对应俩个值 类型为boolean  true或false
     */
    handlerIsArrow(i) {
      const { length } = this.sourceData.conditionList
      // 节点数小于3个时或最后一个节点
      if (length < 3 || i === length - 1) return [false, false]
      let [leftArrow, rightArrow] = [true, true]
      // 首个节点没有左移
      if (i < 1) leftArrow = false
      if (i >= length - 2) rightArrow = false
      return [leftArrow, rightArrow]
    }
  }
}
</script>

<style lang="scss" scoped>
@import './node.scss';
.title-input {
  max-width: 80%;
  transform: translateY(-2px);
  font-size: 12px;
}
</style>
